import FilterButton from "./components/FilterButton";
import FilterPanel from "./components/FiltersPanel";
import SortPanel from "./components/SortPanel";
import Report from "./components/Report";
import ReportToolbar from "./components/ReportToolbar";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  selectPages,
  selectMetadata,
  setMetadata,
  setSchools,
} from "./redux/reportSlice";
import React, { useEffect } from "react";
import getMetadata from "./Common/getMetadata";
import "./ReportContainer.css";
import config from "./config";

export default function ReportContainer() {
  const dispatch = useDispatch();
  const metadata = useSelector(selectMetadata);
  const { id } = useParams();

  useEffect(() => window.scrollTo(0, 0), []);

  useEffect(() => {
    if (id && dispatch) {
      getMetadata(id).then((meta) => {
        dispatch(setMetadata(meta));
      });
    }
  }, [id, dispatch]);

  let markup = <h1>Loading...</h1>;

  if (metadata) {
    markup = (
      <React.Fragment>
        <link
          href={
            config.adminPortalWebsiteOrigin +
            "/Content/themes/assets/global/plugins/bootstrap-datepicker/css/datepicker.css"
          }
          rel="stylesheet"
        />
        <link
          href={
            config.adminPortalWebsiteOrigin +
            "/Content/CustomCSS/viewButtons.css"
          }
          rel="stylesheet"
        />
        <link
          href={
            config.adminPortalWebsiteOrigin +
            "/Content/CustomCSS/Application.css"
          }
          rel="stylesheet"
        />
        <link
          href={
            config.adminPortalWebsiteOrigin +
            "/Content/CustomCSS/Reports.css?v=1.3"
          }
          rel="stylesheet"
        />
        <h1>{((metadata || {}).header || {}).title}</h1>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-3 text-left no-print control-panel">
              <FilterButton
                filterUrl={metadata.dataSource}
                label={"Run Report"}
              />
              <FilterPanel></FilterPanel>
              <SortPanel />
            </div>
            <ReportToolbar />
            <div className="col-sm-9">
              <div className="report-viewer">
                <Report />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  return markup;
}
